interface IsPaymentMethodRequiredParams {
  doesOfferHaveTrial: boolean;
  doesOrderHaveFullForeverDiscount: boolean;
  doesTrialRequirePaymentMethod: boolean;
  doesTrialRequireUpfrontPayment: boolean;
}

/**
 * Determines if payment method collection is required for this checkout.
 *
 * This is injected as `isPaymentMethodRequired` prop to PaywallCheckoutAttemptsProvider.
 * It answers: "Do we need to collect a payment method?"
 *
 * Payment method is required when:
 * - Subscription without trial (will charge after initial period)
 * - Trial that requires upfront payment
 * - Trial that requires card for future billing
 *
 * Payment method is NOT required when:
 * - Forever discount applied (never charges)
 * - One-time purchase at $0 (no future billing)
 * - Trial without card requirement
 */
export const isPaymentMethodRequired = ({
  doesOfferHaveTrial,
  doesOrderHaveFullForeverDiscount,
  doesTrialRequirePaymentMethod,
  doesTrialRequireUpfrontPayment,
}: IsPaymentMethodRequiredParams): boolean => {
  // Forever discount = never charges = no payment method needed
  if (doesOrderHaveFullForeverDiscount) {
    return false;
  }

  // No trial: payment method required for ongoing billing
  if (!doesOfferHaveTrial) {
    return true;
  }

  // Trial with upfront payment OR trial requires card for future billing
  return doesTrialRequireUpfrontPayment || doesTrialRequirePaymentMethod;
};
